import cookieconsent from 'cookieconsent'; // eslint-disable-line no-unused-vars
// importing of cookieconsent library will put itself under window.cookieconsent

import defaultConfig from './config.default';
import resolveLanguage from './languages';
import privacyPolicy from './privacyPolicy';

export default function (config = {}) {
  // Disable auto-float on mobile feature of the library.
  // see: https://github.com/insites/cookieconsent/blob/master/src/cookieconsent.js#L648
  window.cookieconsent.utils.isMobile = () => false;

  const effectiveConfig = window.cookieconsent.utils.deepExtend(defaultConfig, config);

  // unique identifier support
  effectiveConfig.cookie.name = effectiveConfig.cookie.name + '-' + effectiveConfig.cookie.identifier;

  // privacy policy languages support
  if (!config.language) {
    throw new Error('language is required to use cvent-cookieconsent');
  }
  if (!effectiveConfig.content.href) {
    const resolvedLanguage = resolveLanguage(config.language);
    effectiveConfig.content.href = privacyPolicy[resolvedLanguage] || effectiveConfig.content.href;
  }

  window.cookieconsent.initialise(effectiveConfig);
}
